module.exports = __webpack_public_path__ + "static/media/lash1.b5b14cb8.png";